import React, {Fragment} from "react";
import {withStyles} from '@material-ui/core/styles';
import {Settings} from "../Utils/Settings.js";

const styles = theme => ({
    newButton: {
        background: "linear-gradient( center top, #79bbff 5%, #4197ee 100% )",
        backgroundColor: "#79bbff",
        borderRadius: "2px",
        border: "1px solid #469df5",
        display: "inline-block",
        color: "#ffffff",
        fontFamily: "Arial",
        fontSize: "11px",
        fontWeight: "bold",
        fontStyle: "normal",
        height: "16px",
        lineHeight: "14px",
        width: "76px",
        textDecoration: "none",
        textAlign: "center",
    },

    soldButton: {
        background: "linear-gradient( center top, #ffc477 5%, #fb9e25 100% )",
        backgroundColor: "#ffc477",
        borderRadius: "2px",
        border: "1px solid #eeb44f",
        display: "inline-block",
        color: "#ffffff",
        fontFamily: "Arial",
        fontSize: "11px",
        fontWeight: "bold",
        fontStyle: "normal",
        height: "16px",
        lineHeight: "14px",
        width: "60px",
        textDecoration: "none",
        textAlign: "center",
    },

    reducedButton: {
        background: "linear-gradient( center top, #9dce2c 5%, #8cb82b 100% )",
        backgroundColor: "#9dce2c",
        borderRadius: "2px",
        border: "1px solid #83c41a",
        display: "inline-block",
        color: "#ffffff",
        fontFamily: "Arial",
        fontSize: "11px",
        fontWeight: "bold",
        fontStyle: "normal",
        height: "16px",
        lineHeight: "14px",
        width: "72px",
        textDecoration: "none",
        textAlign: "center",
    },

    printButton: {
        fontSize: "14px",
        fontStyle: "normal",
        fontFamily: "Arial",
        cursor: "Pointer"
    }
});

function ReducedButton(elementProps) {
    const {classes} = elementProps;
    return <div className={classes.reducedButton}>Reduced!</div>
}

function NewButton(elementProps) {
    const {classes} = elementProps;
    return <div className={classes.newButton}>New listing</div>
}

function SoldButton(elementProps) {
    const {classes} = elementProps;
    return <div className={classes.soldButton}>Sold</div>
}

function PrintButton(elementProps) {
    const {classes} = elementProps;
    if (Settings.showPrintButton) {
        return <span onClick={() => window.print()} className={classes.printButton}>{Settings.printButtonText}</span>
    } else {
        return <Fragment></Fragment>
    }
}

const reducedButton = withStyles(styles)(ReducedButton);
const newButton = withStyles(styles)(NewButton);
const soldButton = withStyles(styles)(SoldButton);
const printButton = withStyles(styles)(PrintButton);
export { reducedButton as ReducedButton, newButton as NewButton, soldButton as SoldButton, printButton as PrintButton };
